import { CostCenterFilterKeyString } from 'InstitutionalManagement/types'
import { COST_CENTER_FIELDS_INITIAL_VALUES } from './costCenterFieldsInitialValues'

export const COST_CENTER_INITIAL_FILTER: CostCenterFilterKeyString = {
  search: '',
  ...COST_CENTER_FIELDS_INITIAL_VALUES,
}
